/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuDisplayPrefsSelect_filters$ref: FragmentReference;
export type SbSharedRefineMenuDisplayPrefsSelect_filters = $ReadOnlyArray<{|
  +name: ?string,
  +values: ?$ReadOnlyArray<?{|
    +displayName: ?string,
    +urlLabel: ?string,
    +link: ?string,
  |}>,
  +$refType: SbSharedRefineMenuDisplayPrefsSelect_filters$ref,
|}>;
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuDisplayPrefsSelect_filters",
  "type": "SearchBrowseFilter",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "values",
      "storageKey": "values(limit:15)",
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 15,
          "type": "Int"
        }
      ],
      "concreteType": "SearchBrowseFilterValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "urlLabel",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "link",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '1e59cd8a51b4f6e4df399a2c4888a215';
module.exports = node;
